module.exports = __webpack_public_path__ + "img/28_20.9c669d22.png";